import { logError } from '~/logger';
import queryGetShopInventory from '~/graphql/shop/queryGetShopInventory';
import messages, { ShopStoreMessage } from '../messages';
import Economy from 'dt-common/constants/Economy';

export default async function refreshShopInventory(
  {
    playerId,
    setShopInventory,
    setLastRestock,
    setRestockTimeout,
    emit,
  }: {
    playerId: string;
    setShopInventory: (val: any[]) => void;
    setLastRestock: (val: number) => void;
    setRestockTimeout: (timeout: NodeJS.Timeout | null) => void;
    emit: (message: ShopStoreMessage, data?: any) => void;
  }
) {
  try {
    const data = await queryGetShopInventory({ playerId });
    setShopInventory(data.shopInventory);
    setLastRestock(data.last_restock);
    emit(messages.SHOP_INVENTORY);

    // Handle next restock
    const next_restock = data.last_restock + Economy.SHOP_RESTOCK_INTERVAL;
    const time_until_restock = next_restock - Date.now();
    if (time_until_restock > 0) {
      const timeout = setTimeout(async () => {
        try {
          await refreshShopInventory({
            playerId,
            setShopInventory,
            setLastRestock,
            setRestockTimeout,
            emit,
          });
        } catch (err) {
          logError(err, {
            module: 'ShopStore',
            func: 'refreshShopInventory/restockTimeout',
          });
        }
      }, time_until_restock);
      setRestockTimeout(timeout);
    }
  } catch (err) {
    logError(err, {
      module: 'ShopStore',
      func: 'refreshShopInventory',
      playerId,
    });
  }
}
